__turbopack_context__.v({
  "phone-section": "O_ABKG_phone-section",
  "phone-section__header": "O_ABKG_phone-section__header",
  "phone-section__header-title": "O_ABKG_phone-section__header-title",
  "phone-section__input-container": "O_ABKG_phone-section__input-container",
  "phone-section__phone-type-input-container": "O_ABKG_phone-section__phone-type-input-container",
  "phone-section__remove-button": "O_ABKG_phone-section__remove-button",
});
